import { getOrgConfig } from './organizationConfigUtil';

/**
 * Writes the active organization's palette onto <html> as CSS custom
 * properties, overriding the generic defaults in src/styles/genericTheme.css.
 *
 * The theme keys in src/config/organizations.js are the CSS variable names
 * themselves, so this stays a dumb copy - adding a token to a brand needs no
 * change here.
 *
 * Also stamps data-org / data-brand on <html> for the rare case where a
 * selector genuinely has to branch on the company (prefer a token first).
 */
export function applyOrgTheme() {
    const org = getOrgConfig();
    if (!org) return;

    const root = document.documentElement;

    Object.entries(org.theme ?? {}).forEach(([token, value]) => {
        if (token.startsWith('--') && value) root.style.setProperty(token, value);
    });

    root.setAttribute('data-org', org.id);
    if (org.legacyBrandName) root.setAttribute('data-brand', org.legacyBrandName);
}

export function applyOrgFavicon() {
    const org = getOrgConfig();
    if (!org?.favicon) return;

    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
    }
    link.href = org.favicon;
}

/** Read a resolved theme token - for canvas/inline styles that can't use var(). */
export function getThemeToken(token, fallback = '') {
    const fromConfig = getOrgConfig()?.theme?.[token];
    if (fromConfig) return fromConfig;

    const computed = getComputedStyle(document.documentElement)
        .getPropertyValue(token)
        .trim();
    return computed || fallback;
}
